export default {
    ERROR_REQUIRED: 'Field is required',
    ERROR_STRING: 'Value should be string',
    ERROR_NUMBER: 'Value should be number',
    ERROR_BOOLEAN: 'Value should be boolean',
    ERROR_EMAIL: 'Value should be email',
    ERROR_MAXLENGTH: 'Value length should be {{criteria}} or less characters',
    ERROR_MINLENGTH: 'Value length should be {{criteria}} or more characters',
    ERROR_MAX: 'Value should be less than or equal to {{criteria}}',
    ERROR_MIN: 'Value should be greater than or equal to {{criteria}}',
    ERROR_REGEX: "Value doesn't match regex {{criteria}}",
    ERROR_LONGITUDE: 'Value should be a valid longitude',
    ERROR_LATITUDE: 'Value should be a valid latitude',
    ERROR_POSITIVE_NUMBER: 'Value should be greater than or equal to 1',
    ERROR_ZERO_OR_HIGER: 'Value should be a number 0 or higher',
    ERROR_DOMAIN: 'Value should be a valid domain',
    ERROR_ZIP_CODE: 'Value should be a valid zip code',
    ERROR_MAX_SELECTION: 'Value should be number higher than 2',
};
